'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import AngularServies from '@/components/technologies/angular-demand';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));

const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Being a top AngularJS web development company, we build intuitive, innovative, and feature-packed custom web apps."
                alt="Angular Js Development"
                title="Angular Js Development"
                width={1090}
                height={604}
                path={'angular-js-hero'}
                bgPath={'hero-bg-grunge-red'}
                color="red"
                isRed={true}
            >
                AngularJS Development<div>Company</div>
            </TechHero>
            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="AngularJS" />
            <ContetVideoSection title="Develop Engaging Web & Mobile Apps With AngularJS">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb Limited is a leading AngularJS development company that builds web apps with the most powerful front
                        end. Our AngularJS app developers create interactive web applications like Netflix, The Guardian, PayPal,
                        Lego, and more. All of these app examples are apps built with the AngularJS framework.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        AngularJS is an open-source, next-generation, JavaScript-based framework to create rich internet
                        applications. Being backed by a robust MVC framework, AngularJS enables us to build fully responsive and
                        dynamic websites like CMS, eCommerce, on-demand apps, and more.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        Beat your competition with a solid app using AngularJS app development.
                    </p>
                </>
            </ContetVideoSection>
            <AngularServies />
            <HireProcess
                bg="bg-angular"
                pageTitle="Hire AngularJS Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using AngularJS."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For AngularJS Application Development?" />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best AngularJS Developers"
                desc="Select from different engagement models to hire AngularJS Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
